import apiClient from './client';

// Lists that can grow (references, comments, images, flags) are paginated with
// `next_cursor`. The screens show them whole, so this follows the cursor to the end.
export const getAllPages = async (url, params = {}) => {
  const items = [];
  let cursor = null;
  do {
    const { data } = await apiClient.get(url, {
      params: { ...params, limit: 200, ...(cursor ? { cursor } : {}) },
    });
    items.push(...data.items);
    cursor = data.next_cursor;
  } while (cursor);
  return items;
};
